import { LucideIcon } from 'lucide-react';
import React from 'react';
import './AtendimentoToReserva.css';

interface TimelineStepProps {
    icon: LucideIcon;
    label: string;
    status: 'pending' | 'active' | 'completed';
}

export const TimelineStep: React.FC<TimelineStepProps> = ({ icon: Icon, label, status }) => {
    return (
        <div className={`timeline-item ${status}`}>
            <div className="icon-box">
                <Icon size={22} />
            </div>
            <span className="timeline-label">{label}</span>
        </div>
    );
};

